import z from "zod";

export const contactAddressModalDataSchema = z.object({});

export type ContactAddressModalDataProps = z.infer<
  typeof contactAddressModalDataSchema
>;
